// extracted by mini-css-extract-plugin
var _1 = "Rszo4T5KKS";
export { _1 as "exampleText" }
